// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Uio0S","count":"styles_count__y5GMC"};